<template>
  <v-layout fill-height column id="tutorialGuide01">
    <v-main class="page-main tutorial-guide-content" :style="{'background-image' : `url(${getImage(background)})`}">
      <v-container fluid class="flex-fill" style="width: auto;">
        <div class="main-top">
          <v-tooltip attach
                     left
                     transition="none"
                     max-width="100vw"
                     class="tooltip-coach"
                     :value="tooltipActive">
            <template v-slot:activator="{ attrs }">
              <v-btn icon :ripple="false"
                     class="btn-notice new"
                     v-bind="attrs"
                     @click.prevent></v-btn>
            </template>
            <span class="tooltip-text" id="tooltipBtnNotice">알림함</span>
          </v-tooltip>
          <!-- 삼성 화재용 로고 -->
          <div v-if="isSamsungFire" class="customer-logo" @click.prevent>
            <img :src="getImage('logo_anyfit.png')"/>
          </div>
          <!-- 삼성 화재용 로고 -->
        </div>
        <div class="greetings">
          <!-- 기본 박스 사이즈 잡아주는 부분 -->
          <div class="greetings-hidden">오늘 하루는 어떤 하루로<br/>남기고 싶나요?</div>
        </div>
        <div class="my-travel-status">
          <button type="button" class="v-btn v-btn--text theme--light v-size--default">
            <span class="v-btn__content">현재 1일째 여행중입니다. </span>
          </button>
          <br>
        </div>
        <MissionAchievement :value="0"
                            type="main"
                            class="mt-2"
        />
      </v-container>
      <slot name="bottomMenu" />
    </v-main>
    <slot />
  </v-layout>
</template>

<script>
import {mixinAuth} from '@/mixins'
import MissionAchievement from "@/components/mission/Achievement.vue";
export default {
  name: 'TutorialSlide1',
  components: {MissionAchievement},
  mixins: [mixinAuth],
  props: ['props'],
  data: () => ({
    tooltipActive: false
  }),
  computed: {
    background () {
      return this.props.background
    }
  },
  mounted () {
    setTimeout(function () {
      this.tooltipActive = true
    }.bind(this), 300)
  }
}
</script>
<style lang="scss" scoped>
.tooltip-coach {
  #tooltipBtnNotice {
    left: 45px;
    top: 45px;
    &:after {
      width: 56px;
      height: 55px;
      left: -50px;
      top: -44px;
      background-image: var(--coach-mark-arrow-02);
    }
  }
}
.tutorial-guide {
  .v-btn.btn-notice {
    position: relative;
    z-index: 8;
  }
}
html:not([data-theme="samsungfire"]) {
  .tutorial-guide {
    .v-btn.btn-notice {
      background-color: var(--v-primary-base) !important;
    }
  }
}
</style>
